import { render, staticRenderFns } from "./_dashboard.vue?vue&type=template&id=c8a7b20c&scoped=true"
import script from "./_dashboard.vue?vue&type=script&lang=js"
export * from "./_dashboard.vue?vue&type=script&lang=js"
import style0 from "./_dashboard.vue?vue&type=style&index=0&id=c8a7b20c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a7b20c",
  null
  
)

export default component.exports